import React, { useState, useRef, useEffect } from 'react';
import style from './ResultCard.module.css';
import LineChart from '../charts/LineChart';

const ResultCard = ({ item, isFavorite, onToggleFavorite }) => {
    const [expanded, setExpanded] = useState(false);
    const contentRef = useRef(null);
    const [height, setHeight] = useState(0);

    useEffect(() => {
        if (expanded && contentRef.current) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [expanded]);

    return (
        <div className={style.card}>
            <div className={style.cardHead}>
                <button
                    className={`${style.star} ${isFavorite ? style.starActive : ''}`}
                    onClick={(e) => {
                        e.stopPropagation();
                        onToggleFavorite?.(item);
                    }}
                >
                    ★
                </button>
                <button className={style.cardInfo} onClick={() => setExpanded(!expanded)}>
                    <div className={style.info}>
                        <span className={style.name} >{item.name}</span>
                        <p><span>결과</span> <b>{item.result}</b></p>
                        <p><span>참고치</span><b>{item.ref}</b></p>
                    </div>
                    <span className={`${style.badge} ${style[item.status]}`}>{item.statusText}</span>
                    <span className={`${style.arrow} ${expanded ? style.arrowUp : ''}`}></span>
                </button>
            </div>

            <div className={style.detailWrap} style={{ height: `${height}px` }}>
                <div ref={contentRef} className={style.detail}>
                    <div className={style.topBox}>
                         {/*  data-compar="up"  */}
                        {/* <div className={style.comparValue} data-compar="down">0.07</div>   */}

                        {/* {item.comparValue !== null && (
                            <div
                                className={style.comparValue}
                                data-compar={item.comparType}
                            >
                                {item.comparValue}
                            </div>
                        )} */}
                        {item.chartType === 'bloodPressure' ? (
                            <div className={style.bpCompar}>
                                {item.comparTopValue !== null && (
                                    <div
                                        className={`${style.comparValue} ${style.brssrTop}`}
                                        data-compar={item.comparTopType}
                                    >
                                        {item.comparTopValue}
                                    </div>
                                )}

                                {item.comparLwetValue !== null && (
                                    <div
                                        className={`${style.comparValue} ${style.brssrLwet}`}
                                        data-compar={item.comparLwetType}
                                    >
                                        {item.comparLwetValue}
                                    </div>
                                )}
                            </div>
                        ) : (
                            item.comparValue !== null && (
                                <div
                                    className={style.comparValue}
                                    data-compar={item.comparType}
                                >
                                    {item.comparValue}
                                </div>
                            )
                        )}

                        {item.description && <p className={style.desc}>{item.description}</p>}
                    </div>

                    <div className={style.bgBox}>
                        <div className={style.legend}>
                            <span data-legend="upper">참고치(상한)</span>
                            <span data-legend="lower">참고치(하한)</span>
                            <span data-legend="result">결과</span>
                        </div>
                        <div className={style.chartWrap}>
                            {item.chartData && item.chartData.length > 0 ? (
                                <LineChart data={item.chartData} _range={item.chartRange} type={item.chartType} />
                            ) : (
                                <p className={style.noChart}>차트 데이터가 없습니다.</p>
                            )}
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    );
};

export default ResultCard;